
const ImportScript = src => {

    if(window.idw === undefined){
      const script = document.createElement('script')
      script.src = src
      //script.async = true
      document.body.appendChild(script)

    }
    return () => {
      var tags = document.getElementsByTagName('script');
      for (var i = tags.length; i >= 0; i--){
        if (tags[i] && tags[i].getAttribute('src') != null && (tags[i].getAttribute('src').indexOf("8180") != -1 ||  tags[i].getAttribute('src').indexOf("loki") != -1)){
         tags[i].parentNode.removeChild(tags[i]); //remove element by calling parentNode.removeChild()
        }
       }
    }

}
export default ImportScript
